<template>
    <div v-if="show" class="rsm-overlay" @click.self="closeModal">
        <transition name="rsm-slide" @after-leave="$emit('after-close')">
            <div v-if="show" class="rsm-panel">
                <div class="rsm-header">
                    <h3 class="rsm-title">{{ title }}</h3>
                    <button class="rsm-close" @click="closeModal" aria-label="Close modal">
                        <i class="fas fa-times"></i>
                    </button>
                </div>
                <div class="rsm-body">
                    <slot></slot>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
export default {
    props: {
        show: {
            type: Boolean,
            default: false,
        },
        title: {
            type: String,
            default: "Modal",
        },
    },
    emits: ["close", "after-close"],
    methods: {
        closeModal() {
            this.$emit("close");
        },
    },
    watch: {
        show(newVal) {
            if (newVal) {
                document.body.style.overflow = "hidden";
            } else {
                document.body.style.overflow = "auto";
            }
        },
    },
    beforeUnmount() {
        document.body.style.overflow = "auto";
    },
};
</script>

<style lang="scss" scoped>
@import "../../assets/variables.scss";

.rsm-overlay {
    position: fixed;
    inset: 0;
    background: rgba(15, 23, 42, 0.35);
    backdrop-filter: blur(3px);
    z-index: 2000;
    display: flex;
    justify-content: flex-end;
    animation: rsmFadeIn 0.25s cubic-bezier(0.4, 0, 0.2, 1);
}

@keyframes rsmFadeIn {
    from {
        opacity: 0;
    }
    to {
        opacity: 1;
    }
}

.rsm-panel {
    width: 50%;
    height: 100vh;
    background: white;
    display: flex;
    flex-direction: column;
    box-shadow: -8px 0 24px rgba(0, 0, 0, 0.12);
    overflow: hidden;
}

.rsm-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 18px 20px;
    border-bottom: 1px solid $gray100;
    background: white;
    flex-shrink: 0;
}

.rsm-title {
    font-size: 15px;
    font-weight: 700;
    color: $gray800;
    margin: 0;
}

.rsm-close {
    width: 32px;
    height: 32px;
    border: 1px solid $gray200;
    border-radius: 6px;
    background: white;
    color: $gray600;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    transition: all $transitionFast;
    flex-shrink: 0;

    &:hover {
        background: $gray50;
        border-color: $gray300;
        color: $gray800;
    }
}

.rsm-body {
    flex: 1;
    overflow-y: auto;
    padding: 16px 20px;
    background: #fafbfc;
}

/* Slide animation */
.rsm-slide-enter-active,
.rsm-slide-leave-active {
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.rsm-slide-enter-from,
.rsm-slide-leave-to {
    transform: translateX(100%);
}

/* Mobile responsive */
@media (max-width: 768px) {
    .rsm-panel {
        width: 100%;
    }

    .rsm-header {
        padding: 14px 16px;
    }

    .rsm-body {
        padding: 12px 16px;
    }

    .rsm-title {
        font-size: 14px;
    }
}

/* Scrollbar styling */
.rsm-body {
    &::-webkit-scrollbar {
        width: 6px;
    }

    &::-webkit-scrollbar-track {
        background: transparent;
    }

    &::-webkit-scrollbar-thumb {
        background: $gray300;
        border-radius: 3px;

        &:hover {
            background: $gray400;
        }
    }
}
</style>
